import { useTheme } from 'styled-components';

import { FilterSearchIcon, TrashIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';
import { Row } from '@components/formStyles';
import Accordion from '@components/Accordion/next/Accordion';
import Typography from '@components/Typography';

import {
  StyledNameFilter,
  NameFilterInputWrapper,
  NameFilterInput,
  NameFilterTitle,
  ClearContainer,
  NameFilterSearchButton,
  CollapsableStyledNameFilter,
  CollapsableNameFilterInputWrapper,
  InputButtonWrapper,
} from './NameFilterStyle';

export interface NameFilterProps {
  title?: string;
  name: string;
  setName: (val: string) => void;
  placeholder: string;
  handleSearch: (name: string) => void;
  inputWrapperClassName?: string;
  withClear?: boolean;
  handleClearKeywordsFilter?: () => void;
  collapsable?: boolean;
}

const NameFilter = ({
  title,
  name,
  setName,
  placeholder,
  handleSearch,
  inputWrapperClassName,
  withClear,
  collapsable,
}: NameFilterProps) => {
  const { palette } = useTheme();
  const { isDesktop } = useDevice();
  const handleSearchButtonClicked = (): void => {
    handleSearch(name);
  };

  const clear = () => {
    setName('');
    handleSearch('');
  };

  return collapsable ? (
    <Accordion
      label={title}
      headerContentColor='NL800'
      alwaysShowBottomBorder={false}
      headerPadding={isDesktop ? '0px' : '15px'}
      mobileLabelFontSize='16px'
      iconSize={16}
      iconColor='NL800'
      borderRadius='8px'
      accordionTitleStyles={{
        color: palette.NL800,
      }}
      contentPadding='0px'
    >
      <CollapsableStyledNameFilter>
        <CollapsableNameFilterInputWrapper className={inputWrapperClassName}>
          <NameFilterInput
            placeholder={placeholder}
            value={name}
            onChange={setName}
            useNative
            icon={
              <CustomIcon
                icon={FilterSearchIcon}
                fontSize={20}
                style={{ marginRight: '4px' }}
              />
            }
            iconLeft={true}
          />
        </CollapsableNameFilterInputWrapper>
        {withClear && name ? (
          <ClearContainer onClick={clear}>
            <CustomIcon
              icon={TrashIcon}
              paletteColor='tomato'
              width={18}
              height={20}
            />
          </ClearContainer>
        ) : null}
        {isDesktop ? (
          <NameFilterSearchButton
            disabled={Boolean(!name)}
            onClick={handleSearchButtonClicked}
          >
            Ara
          </NameFilterSearchButton>
        ) : null}
      </CollapsableStyledNameFilter>
    </Accordion>
  ) : (
    <StyledNameFilter>
      <Row>
        <NameFilterTitle>
          <Typography variant='caption1' color='NL800' weight='Bold'>
            {title}
          </Typography>
        </NameFilterTitle>
        {withClear && name ? (
          <ClearContainer onClick={clear}>
            <CustomIcon
              icon={TrashIcon}
              paletteColor='tomato'
              width={18}
              height={20}
            />
          </ClearContainer>
        ) : null}
      </Row>

      <InputButtonWrapper>
        <NameFilterInputWrapper className={inputWrapperClassName}>
          <NameFilterInput
            placeholder={placeholder}
            value={name}
            onChange={setName}
            useNative
            icon={
              <CustomIcon
                icon={FilterSearchIcon}
                fontSize={20}
                style={{ marginRight: '4px' }}
              />
            }
            iconLeft={true}
          />
        </NameFilterInputWrapper>

        {isDesktop ? (
          <NameFilterSearchButton
            disabled={Boolean(!name)}
            onClick={handleSearchButtonClicked}
          >
            Ara
          </NameFilterSearchButton>
        ) : null}
      </InputButtonWrapper>
    </StyledNameFilter>
  );
};

export default NameFilter;
